/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { LabSelect } from "../../../components/course/select";
import { CustomLabel } from "../../../ui/labels";
import { ButtonPrimary } from "../../../ui/buttons";

const ReasonForCosureModal = ({ toggle, isOpen, handleCerrarSinCubrir, motivos }) => {
  const [continuarMotivo, setContinuarMotivo] = useState(false);
  const [motivoValue, setMotivoValue] = useState(null);
  const [mostrarError, setMostrarError] = useState(false);

  const motivosCubrir = motivos ? motivos.filter((e) => e.label === "Cubierta") : [];
  const motivosOptions = motivosCubrir.map((e) => {
    return { label: e.text, value: e.text };
  });

  const handleReactSelectChange = (selected) => {
    setMotivoValue(selected);
  };

  const inputError = () => {
    const error = { error: false };

    if (motivoValue === null) {
      error.mensaje = "debe seleccionar un motivo";
    } else {
      error.error = false;
    }

    return error;
  };

  const messageError = inputError();

  const handleClick = () => {
    setMostrarError(true);
    if (messageError.mensaje) {
      toast.error(messageError.mensaje);
    } else {
      toast.success("Nota de pedido cerrada");
      handleCerrarSinCubrir(motivoValue.value);
      toggle();
      setContinuarMotivo(false);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen}>
        <ModalBody>
          {continuarMotivo ? (
            <>
              <div className="px-4 pt-4">
                <p style={{ fontSize: "18px", fontFamily: "Nunito" }}>Ingrese el motivo de cierre de la nota de pedido</p>
              </div>
              <div className="col-md-10">
                {/* <div className="row"> */}
                <div className="">
                  <div className="form-group">
                    <CustomLabel htmlFor="motivo" className="col-form-label pt-0 w-100">
                      Motivo de cierre
                      <LabSelect
                        border="solid 1px #ced4da"
                        id="motivo"
                        name="motivo"
                        className="w-100"
                        onChange={handleReactSelectChange}
                        value={motivoValue}
                        placeholder="Todo"
                        isClearable
                        // isLoading={isLoadingPiAsignable}
                        // isDisabled={isLoadingPiAsignable}
                        options={motivosOptions}
                      />
                    </CustomLabel>
                    {messageError && mostrarError && <div className="input-feedback text-center">{messageError.mensaje}</div>}
                  </div>
                </div>
                {/* </div> */}
              </div>
            </>
          ) : (
            <>
              <div className="px-4 pt-4">
                <p style={{ fontSize: "18px", fontFamily: "Nunito" }}>¿La nota de pedido no esta cubierta al 100%, desea continuar de todas formas?</p>
              </div>
            </>
          )}
        </ModalBody>
        {continuarMotivo ? (
          <ModalFooter>
            <Button color="btn-secondary" onClick={toggle} type="button">
              Cancelar
            </Button>
            <ButtonPrimary onClick={handleClick} type="button">
              Confirmar
            </ButtonPrimary>
          </ModalFooter>
        ) : (
          <ModalFooter>
            <Button color="btn-secondary" onClick={toggle} type="button">
              Cancelar
            </Button>
            <ButtonPrimary onClick={() => setContinuarMotivo(true)} type="button">
              Continuar
            </ButtonPrimary>
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};

export default ReasonForCosureModal;
